import * as Sentry from '@sentry/vue'
import { APP_ENVIRONMENT, APP_SENTRY_KEY, APP_SENTRY_PROJECT } from '@/micro/utils/environment'

export default function ({ app }: { app: any }) {
  if (APP_SENTRY_KEY.length && APP_SENTRY_PROJECT.length) {
    Sentry.init({
      app,
      dsn: `https://${APP_SENTRY_KEY}.sentry.io/${APP_SENTRY_PROJECT}`,
      environment: String(APP_ENVIRONMENT),
      attachStacktrace: true,
      integrations: [
        Sentry.vueIntegration({ attachProps: true }),
        Sentry.httpClientIntegration({ failedRequestStatusCodes: [[500, 504]] }),
      ],
      ignoreErrors: [
        'ChunkLoadError',
        'UnhandledRejection',
        'callback',
        'callback: Object captured as exception with keys: data, message, status',
        "Cannot read properties of null (reading 'CodeMirror')",
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        "Can't find variable: __AutoFillPopupClose__",
        "Cannot read properties of undefined (reading 'domInteractive')",
        "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
        'UET is not defined',
        "undefined is not an object (evaluating 'window.webkit.messageHandlers[e].postMessage')",
        "undefined is not an object (evaluating 'window.webkit.messageHandlers[t].postMessage')",
        'Java bridge method invocation error',
        "Unexpected token '<'",
        '[Cloudflare Turnstile] Error: 300010.',
        '[Cloudflare Turnstile] Error: 300030.',
        '[Cloudflare Turnstile] Error: 300031.',
        'Event `CustomEvent` (type=unhandledrejection) captured as promise rejection',
        "Can't find variable: Chartboost",
        "xbrowser is not defined",
      ],
    })
  }
}
